module.exports = __webpack_public_path__ + "static/media/mobileClose.f03f4ea1.svg";